import { Image, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function NoDataSection({
  description,
  content = "No data yet",
  ...rest
}) {
  const { t } = useTranslation();
  return (
    <Stack
      flexGrow={1}
      w="full"
      h="full"
      rounded="md"
      bgColor="white"
      {...rest}
    >
      <Stack w="full" h="full" justify="center" align="center" py={6}>
        <Text align="center">{t(description)}</Text>
        {!description && (
          <Image src="/images/no_data.svg" alt={t("No data image")} />
        )}
        <Text>{t(content)}</Text>
      </Stack>
    </Stack>
  );
}
